"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIBRARY_DESCRIPTION_MAX_LENGTH = exports.LIBRARY_TITLE_MAX_LENGTH = void 0;
exports.LIBRARY_TITLE_MAX_LENGTH = 1024;
exports.LIBRARY_DESCRIPTION_MAX_LENGTH = 65535;
//# sourceMappingURL=library.js.map